const initState = {
  laptopsFiltered: [],
  specsModalVisible: false,
  currentLaptop: ''
}

export const LAPTOP_RESULTS_PAGE_LAPTOPS_FILTERED_UPDATE = "LAPTOP_RESULTS_PAGE_LAPTOPS_FILTERED_UPDATE";
export const updateLaptopResultsPageLaptopsFiltered = (val) => ({type: LAPTOP_RESULTS_PAGE_LAPTOPS_FILTERED_UPDATE, payload: val});

export const LAPTOP_RESULTS_PAGE_SPECS_MODAL_UPDATE = "LAPTOP_RESULTS_PAGE_SPECS_MODAL_UPDATE";
export const updateLaptopResultsPageSpecsModal = (val) => ({type: LAPTOP_RESULTS_PAGE_SPECS_MODAL_UPDATE, payload: val});

export const LAPTOP_RESULTS_PAGE_CURRENT_LAPTOP_UPDATE = "LAPTOP_RESULTS_PAGE_CURRENT_LAPTOP_UPDATE";
export const updateLaptopResultsPageCurrentLaptop = (val) => ({type: LAPTOP_RESULTS_PAGE_CURRENT_LAPTOP_UPDATE, payload: val});


export default (state = initState, action) => {
  switch (action.type) {
    case LAPTOP_RESULTS_PAGE_LAPTOPS_FILTERED_UPDATE:
      return {...state, laptopsFiltered: action.payload};
    case LAPTOP_RESULTS_PAGE_SPECS_MODAL_UPDATE:
      return {...state, specsModalVisible: action.payload};
    case LAPTOP_RESULTS_PAGE_CURRENT_LAPTOP_UPDATE:
      return {...state, currentLaptop: action.payload};
    default:
      return state;
  }
}


// WEBPACK FOOTER //
// ./src/reducers/laptopResultsPageReducer.js